import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IntlProvider, load, loadMessages, LocalizationProvider } from '@progress/kendo-vue-intl';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import { onBeforeMount, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LangWrapper',
  props: {
  language: { type: String, required: true },
  locale: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const appLanguage = ref('en');
const appLocale = ref('en-GB');

const isLocaleFilesLoading = ref(false);

async function loadLocaleFiles() {
  appLocale.value = props.locale;
  appLanguage.value = props.language;

  await loadLocaleFilesByLocale();
  await loadMessagesByLocale();
  isLocaleFilesLoading.value = true;
}

async function loadLocaleFilesFor(localeFolder: string) {
  const numbers = await import(`cldr-numbers-full/main/${localeFolder}/numbers.json`);
  const caGregorian = await import(`cldr-dates-full/main/${localeFolder}/ca-gregorian.json`);
  const dateFields = await import(`cldr-dates-full/main/${localeFolder}/dateFields.json`);
  const timeZoneNames = await import(`cldr-dates-full/main/${localeFolder}/timeZoneNames.json`);
  const currencies = await import(`cldr-numbers-full/main/${localeFolder}/currencies.json`);

  return { numbers, caGregorian, dateFields, timeZoneNames, currencies };
}

async function loadLocaleFilesByLocale() {
  try {
    const { numbers, caGregorian, dateFields, timeZoneNames, currencies } =
      await loadLocaleFilesFor(props.locale);

    load(
      likelySubtags,
      currencyData,
      weekData,
      numbers,
      caGregorian,
      dateFields,
      timeZoneNames,
      currencies,
    );
  } catch (e) {
    try {
      console.warn('Language file by locale is missing! Second attempt with short lang name', e);
      const localeFolder = props.locale.split('-')[0];
      const { numbers, caGregorian, dateFields, timeZoneNames, currencies } =
        await loadLocaleFilesFor(localeFolder);

      load(
        likelySubtags,
        currencyData,
        weekData,
        numbers,
        caGregorian,
        dateFields,
        timeZoneNames,
        currencies,
      );
    } catch (e) {
      console.error('Language file by locale is missing! Start trying to load it by language.', e);
      appLocale.value = props.language;
      loadLocaleFilesByLanguage();
    }
  }
}

async function loadLocaleFilesByLanguage() {
  try {
    const { numbers, caGregorian, dateFields, timeZoneNames, currencies } =
      await loadLocaleFilesFor(props.locale);

    load(
      likelySubtags,
      currencyData,
      weekData,
      numbers,
      caGregorian,
      dateFields,
      timeZoneNames,
      currencies,
    );
  } catch (e) {
    console.warn('Language file by language code is missing!', e);
  }
}

async function loadMessagesByLocale() {
  try {
    const messages = await import(`@/assets/messages/${props.locale}/${props.locale}.json`);
    loadMessages(messages?.default, props.language);
  } catch (e) {
    console.warn('Messages file by locale is missing! Start trying to load it by language.', e);
    await loadMessagesByLanguage();
  }
}

async function loadMessagesByLanguage() {
  try {
    const messages = await import(`@/assets/messages/${props.language}/${props.language}.json`);
    loadMessages(messages?.default, props.language);
  } catch (e) {
    console.error('Messages file by language missing!', e);
  }
}

onBeforeMount(async () => {
  await loadLocaleFiles();
});

watch(
  () => props.language,
  async () => {
    await loadLocaleFiles();
  },
);

return (_ctx: any,_cache: any) => {
  return (isLocaleFilesLoading.value)
    ? (_openBlock(), _createBlock(_unref(LocalizationProvider), {
        key: 0,
        language: appLanguage.value,
        class: "localization-provider"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IntlProvider), {
            locale: appLocale.value,
            class: "intl-provider"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["locale"])
        ]),
        _: 3
      }, 8, ["language"]))
    : _createCommentVNode("", true)
}
}

})